module.exports = __webpack_public_path__ + "img/horizontal_4_6_8019.6abfed39.png";